module.exports = __webpack_public_path__ + "img/list_alt_outlined.c1ff45d2.svg";